"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMask = void 0;
var react_1 = require("react");
var validLetter = function (char, formatChar) {
    return formatChar === 'A' && char && /^[A-Za-z]$/.test(char);
};
var validNumeric = function (char, formatChar) {
    return formatChar === '#' && char && /^[0-9]$/.test(char);
};
var useMask = function (mask) {
    var applyMask = (0, react_1.useCallback)(function (inputValue) {
        if (!mask) {
            return inputValue;
        }
        else if (inputValue.length > mask.length) {
            return inputValue.slice(0, mask.length);
        }
        var maskedValue = '';
        var formatIndex = 0;
        for (var i = 0; i < inputValue.length; i++) {
            var currentFormatChar = mask[formatIndex] || '';
            var inputChar = inputValue[i] || '';
            if (validNumeric(inputChar, currentFormatChar) ||
                validLetter(inputChar, currentFormatChar)) {
                maskedValue += inputChar;
                formatIndex++;
            }
            else {
                if (currentFormatChar === inputChar) {
                    maskedValue += inputChar;
                    formatIndex++;
                }
                else {
                    var nextFormatChar = currentFormatChar;
                    while (!['A', '#'].includes(nextFormatChar)) {
                        maskedValue += nextFormatChar;
                        nextFormatChar = mask[formatIndex + 1];
                        if (validNumeric(inputChar, nextFormatChar) ||
                            validLetter(inputChar, nextFormatChar)) {
                            maskedValue += inputChar;
                            formatIndex++; // move index an additional step to account for missing character
                        }
                        formatIndex++;
                    }
                }
            }
        }
        return maskedValue;
    }, [mask]);
    return { applyMask: applyMask };
};
exports.useMask = useMask;
